import type { RouteObject } from 'react-router';

import { Layout } from '../components';
import { OrderComplete } from '../pages/OrderComplete/OrderComplete';
import { OrderCompleteMobile } from '../pages/OrderCompleteMobile/OrderCompleteMobile';

export const orderCompleteRoute = (isMobile = false): RouteObject => ({
  children: [
    {
      element: isMobile ? <OrderCompleteMobile /> : <OrderComplete />,
      path: 'reservation/:reservationId/order-complete',
    },
  ],
  element: <Layout passwordProtected={false} isFullScreen />,
});
